import { render, staticRenderFns } from "./PublicResultsA.vue?vue&type=template&id=d58e1bc4&"
import script from "./PublicResultsA.vue?vue&type=script&lang=js&"
export * from "./PublicResultsA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports